export default __webpack_public_path__ + "static/media/P314.1.90a1f076.mp3";